class BackgroundTask {
    type = null;
    asked = [];
    finished = [];
    inProgress = [];
    issued = [];
    planned = [];
    available = {};
    state = null;

    constructor(datas = {}) {
        this.setAttributes(datas);
    }

    setAttributes(datas) {
        let keys = Object.keys(this);
        let key = "";

        for(let i in keys) {
            key = keys[i];

            if (datas[key] !== undefined) {
                switch(key) {
                    case "asked":
                    case "finished":
                    case "inProgress":
                    case "issued":
                    case "planned":
                    case "available":
                        Reflect.set(this, key, (datas[key] === null ? [] : datas[key]));
                        break;
                    default:
                        Reflect.set(this, key, datas[key]);
                        break;
                }
            }
        }
    }
}

export default BackgroundTask;